<template>
  <div class="classlist">
    <Header />
    <Nav />
    <div class="pages">
      <div class="classlist-menu">
        宏云课堂
        <img src="../assets/icon/right-gray.svg" alt="">
        全部课程
      </div>
      <div class="classlist-type">
        <div class="classlist-type-item" v-for="(item,index) in menuList" :key="index">
          <b>{{item.name}}：</b><i>全部</i>
          <div class="classlist-type-check">
              <div class="p" v-for="(its,ins) in item.children" :key="ins + '00'" @click="(typeItemCommoneIndex=ins)">
                <u :class="{'active':typeItemCommoneIndex==ins&&index===3}">{{its.name}}</u>
                <div class="classlist-type-children" v-if="its.children.length>1&&typeItemCommoneIndex==ins">
                <span v-for="(v,k) in its.children" :key="k + '0000'">{{v.name}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="classlist-sort">
        <span class="active">最新</span>
        <span>销量</span>
        <span>折扣</span>
        <span class="mr14">直播</span>
        <i>|</i>
        <b>课程类型：</b>
        <span>精品课</span>
        <span>训练营</span>
        <div class="classlist-sort-revers">
          <img src="../assets/icon/revers.svg" alt="">
          <span>重置筛选</span>
        </div>
      </div>
      <div class="classlist-list">
        <dl @click="goHref('/classDetails?id=1')">
          <dt><img src="../assets/home/list1img.png" /></dt>
          <dd>
            <h5><span>采购</span>《关于疫情防控期间开展政府采购活动有关...</h5>
            <p>讲师：吴小明 | 28课时</p>
            <div class="classlist-list-time">
              <div class="left">
                <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
                <b>精品课</b>
              </div>
              <div class="right">
                <b><i>￥</i>399</b>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt><img src="../assets/class/class1.png" /></dt>
          <dd>
            <h5><span>采购</span>国有企业采购全流程风险控制与热点问题解析系列课程</h5>
            <p>讲师：陈全 | 8课时</p>
            <div class="classlist-list-time">
              <div class="left">
                <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
                <b>精品课</b>
              </div>
              <div class="right">
                <b><i>￥</i>799</b>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt><img src="../assets/class/class12.png" /></dt>
          <dd>
            <h5><span>采购</span>国有企业招标采购合法合规与非招标采购实务操作及热点问题风...</h5>
            <p>讲师：刘玲 | 11课时</p>
            <div class="classlist-list-time">
              <div class="left">
                <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
                <b>精品课</b>
              </div>
              <div class="right">
                <b><i>￥</i>328</b>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt><img src="../assets/class/class3.png" /></dt>
          <dd>
            <h5><span>采购</span>国有企业采购管理规范、招标采购操作实务及采购文件示范文本使...</h5>
            <p>讲师：刘一迪 | 13课时</p>
            <div class="classlist-list-time">
              <div class="left">
                <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
                <b>精品课</b>
              </div>
              <div class="right">
                <b><i>￥</i>736</b>
              </div>
            </div>
          </dd>
        </dl>
      </div>
      <div class="classlist-list m25 pt0 pb20">
        <dl>
          <dt><img src="../assets/class/class7.png" /></dt>
          <dd>
            <h5><span>采购</span>政府采购专职从业人员线上培训班</h5>
            <p>讲师：安帅 | 6课时</p>
            <div class="classlist-list-time">
              <div class="left">
                <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
                <b>精品课</b>
              </div>
              <div class="right">
                <b><i>￥</i>799</b>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt><img src="../assets/class/class4.png" /></dt>
          <dd>
            <h5><span>采购</span>【精品在线课程】招标采购基础能力提升</h5>
            <p>讲师：罗慧泰 | 12课时</p>
            <div class="classlist-list-time">
              <div class="left">
                <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
                <b>精品课</b>
              </div>
              <div class="right">
                <b><i>￥</i>899</b>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt><img src="../assets/class/class5.png" /></dt>
          <dd>
            <h5><span>采购</span>招标投标法律法规与实务操作、招标方案与招标文件编制要点与技巧</h5>
            <p>讲师：黄涛 | 5课时</p>
            <div class="classlist-list-time">
              <div class="left">
                <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
                <b>精品课</b>
              </div>
              <div class="right">
                <b><i>￥</i>1299</b>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt><img src="../assets/class/class6.png" /></dt>
          <dd>
            <h5><span>采购</span>招投标疑难法律问题与案例分析</h5>
            <p>讲师：冯先进 | 9课时</p>
            <div class="classlist-list-time">
              <div class="left">
                <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
                <b>精品课</b>
              </div>
              <div class="right">
                <b><i>￥</i>1808</b>
              </div>
            </div>
          </dd>
        </dl>
      </div>
    </div>
    <Fixed />
    <Footer />
  </div>
</template>

<script>
import menuList from "@/assets/data/classList.js";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Nav from "@/components/Nav.vue";
import Fixed from "../components/Fixed.vue";
export default {
  name: "Classlist",
  components: {
    Header,
    Nav,
    Footer,
    Fixed,
  },
  data() {
    return {
      menuList,
      typeItemCommoneIndex: 4
    };
  },
  methods: {
    goHref(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang="less" scoped>
.classlist {
  &-menu {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    padding-top: 40px;
    padding-bottom: 20px;
    img {
      margin-left: 4px;
      margin-right: 4px;
    }
  }
  &-type {
    width: 1300px;
    margin: 0 auto;
    height: 270px;
    background: #ffffff;
    border-radius: 6px;
    padding: 27px 0 45px 24px;
    box-sizing: border-box;
    &-item {
      display: flex;
      align-items: center;
      margin-top: 22px;
      b {
        width: 5em;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 20px;
        text-align: right;
      }
      i {
        display: inline-block;
        width: 40px;
        height: 22px;
        background: #fff2f0;
        border-radius: 2px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ff4d4f;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        margin-left: 7px;
      }
    }
    &-check {
      position: relative;
        .p {
          display: inline-block;
        margin-left: 36px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 20px;
        cursor: pointer;
          u {
            padding: 1px 4px;
            text-decoration: none;
            &.active {
              background: #FFF1F0;
              border-radius: 2px;
              font-size: 14px;
              color: #B6141A;
            }
          }
        }
    }
    &-children {
      position: absolute;
      left: -40px;
      top: 30px;
      width: 1000px;
      height: 40px;
      background: rgba(255,126,32,0.08);
      border-radius: 2px;
      padding-left: 76px;
      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3E414D;
        line-height: 40px;
        margin-right: 39px;
      }
    }
  }
  &-sort {
    width: 1300px;
    margin: 24px auto 0;
    background: #fff;
    padding-left: 15px;
    box-sizing: border-box;
    padding-top: 15px;
    display: flex;
    align-items: center;
    span {
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-right: 24px;
      cursor: pointer;
      &.active {
        display: inline-block;
        width: 70px;
        height: 36px;
        background: #f6f8fb;
        border-radius: 18px;
        font-size: 14px;
        font-family: PingFangHK-Semibold, PingFangHK;
        font-weight: 600;
        color: #000000;
        line-height: 36px;
        text-align: center;
        margin-right: 27px;
      }
    }
    i {
      font-style: normal;
      color: #979797;
    }
    b {
      font-size: 14px;
      font-family: PingFangHK-Semibold, PingFangHK;
      font-weight: 600;
      color: #000000;
      line-height: 20px;
      margin-left: 20px;
      margin-right: 13px;
    }
    &-revers {
      margin-left: 92px;
      img {
        width: 12px;
        height: 12px;
        margin-right: 6px;
        cursor: pointer;
      }
    }
  }
  &-list {
    background: #fff;
    padding: 35px 7px;
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    dl {
      width: 310px;
      dt {
        line-height: 0;
        img {
          width: 310px;
          height: 180px;
        }
      }
      dd {
        padding: 0 12px;
        border: 1px solid #eeeeee;
        box-sizing: border-box;
        margin-top: -1px;
        padding-top: 17px;
        h5 {
          font-size: 17px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 27px;
          height: 54px;
          span {
            display: inline-block;
            width: 40px;
            height: 20px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 20px;
            background: #ff6154;
            border-radius: 2px;
            text-align: center;
          }
        }
        p {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 19px;
          margin-top: 8px;
        }
      }
    }
    &-time {
      padding-top: 18px;
      margin: 17px 0;
      border-top: 1px solid #eee;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        img {
          width: 15px;
          height: 15px;
        }
        span {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 19px;
          margin-left: 2px;
          i {
            font-style: normal;
            color: #ff8243;
          }
        }
        b {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 19px;
        }
      }
      .right {
        u {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 19px;
          text-decoration: line-through;
          padding-right: 4px;
        }
        b {
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ff1d00;
          line-height: 24px;
          i {
            font-size: 15px;
            font-style: normal;
          }
        }
      }
    }
  }
}
.mr14 {
  margin-right: 14px !important;
}
.pt0 {
  padding-top: 0 !important;
}
.pb20 {
  padding-bottom: 20px;
}
</style>